
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h4c0n", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c6cc1f52f15d5ad1$export$6503ec6e8aabbaf; }, function (v) { return $c6cc1f52f15d5ad1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $c6cc1f52f15d5ad1$export$f7ad0328861e2f03; }, function (v) { return $c6cc1f52f15d5ad1$export$f7ad0328861e2f03 = v; });
var $c6cc1f52f15d5ad1$export$6503ec6e8aabbaf;
var $c6cc1f52f15d5ad1$export$f7ad0328861e2f03;
"use strict";
var $c6cc1f52f15d5ad1$var$mapping = new Map();
function $c6cc1f52f15d5ad1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c6cc1f52f15d5ad1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c6cc1f52f15d5ad1$var$resolve(id) {
    var resolved = $c6cc1f52f15d5ad1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c6cc1f52f15d5ad1$export$6503ec6e8aabbaf = $c6cc1f52f15d5ad1$var$register;
$c6cc1f52f15d5ad1$export$f7ad0328861e2f03 = $c6cc1f52f15d5ad1$var$resolve;

});

var $fbf0047e59d60c1a$exports = {};

(parcelRequire("h4c0n")).register(new URL("", import.meta.url).toString(), JSON.parse('["3z9Oy","index.908543d0.js","aL34s","About.599c6c29.js","4BGze","Typography.a787a597.js","3cPES","Divider.9f0c6f84.js","fp26i","Button.56188b90.js","f0KeL","Button.96840aff.js","4aRns","ContentPaper.1aad0769.js","3dYpU","Paper.0487f8bc.js","cMaWm","ContentPaper.f34ba802.css","6oH5X","Projects.db1f4944.js","cKrGb","OpenInNew.60ac3510.js","eM5Ox","Article.8db49561.js","6RCCG","Grid2.cec99c65.js","kHC0Y","Chips.4b0c07c8.js","kJGZB","Chip.e5a39544.js","dDVAu","dist.5bb8da2a.js","7vrw7","ConsentBanner.73611a93.js","l52V3","Security.045af093.js","EMN7t","GppGood.5e6881ea.js","e40uW","GppBad.f0dbada0.js","MrbHu","DataObject.4b73501b.js","eA7Ph","Timeline.33afdcdc.js","9i46f","TimelineItem.f2447427.js","3LYjv","TimelineSeparator.e0336f0b.js","lDAlv","TimelineConnector.d220ac38.js","bDGM5","FormControlLabel.bd548c66.js","8buYQ","FormGroup.a37660fd.js","iPCoQ","Box.45185c80.js","184nT","ButtonGroup.d800a6ae.js","cZuHR","TimelineDot.acc12804.js","2TLy9","AccessTime.47118419.js","6gDuM","School.8c5b553f.js","dRmxg","EmojiEvents.92fe0cfc.js","dQcpw","Celebration.fbde3220.js","bkRRH","Lightbulb.f2db2d0d.js","awJUK","Work.4c78e655.js","jSCjb","track.77433928.png","kRB2T","autonomous-driving.82f04c0f.pdf","4OGXj","wbs-1.6e2794df.png","8is5Z","wbs-2.2d3d53d9.png","ffEqx","wbs-3.2bce1c2f.png","7ITxa","wbs-4.0b1ca3f4.png","gleQk","main-seminar-1.3b77dc3d.png","aqJGy","main-seminar.9434777d.pdf","1hv5C","scholarship-1.63e48731.jpg","2nPnl","minecraft-plugin-1.0f5c7f4c.png","92w0c","cursor.3a43610b.jpeg","hXzAo","thesis.53420b4c.pdf","d1aLq","Imprint.9f06ed96.js","iHyWy","bg-light.7952c70f.png","iSSjd","bg-dark.eb61a23f.png","kmETd","BasicInformation.6fb2adb4.js","hzpX5","me.67baa0cb.jpg","8AHzA","SocialLinks.20265618.js","23sLG","Container.6601cec6.js","6agA8","Tooltip.423a892b.js","5Kutp","Tooltip.7c30b203.js","ftH14","GitHub.4e55e123.js","asMhf","LinkedIn.42582887.js","j3nh9","Instagram.19196f4f.js","5npkf","Email.d6208456.js","5fxTO","Avatar.92923346.js","hpOac","Navbar.1c3ba2eb.js","arkc0","Brightness7.1a7ebb69.js","kxgdu","Brightness4.4fa0f378.js","99AO6","CssBaseline.debddcc2.js","4jlb8","GlobalStyles.dfafebfa.js"]'));


//# sourceMappingURL=index.runtime.60cfe50a.js.map
